export default "__VITE_ASSET__LZrtxRhS__"